"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsEnumToJSON = exports.PaymentMethodsEnumFromJSONTyped = exports.PaymentMethodsEnumFromJSON = exports.PaymentMethodsEnum = void 0;
/**
 * Payment type
 * @export
 */
exports.PaymentMethodsEnum = {
    Institution: 'institution',
    Insurance: 'insurance',
    Patient: 'patient',
    Medicare: 'medicare',
    None: 'none',
    PatientAccessProgram: 'patient_access_program',
    ChannelRevenue: 'channel_revenue',
    InvitaeExperience: 'invitae_experience',
    VusResolution: 'vus_resolution',
    ReRequisition: 're_requisition',
    Other: 'other',
    Free: 'free'
};
function PaymentMethodsEnumFromJSON(json) {
    return PaymentMethodsEnumFromJSONTyped(json, false);
}
exports.PaymentMethodsEnumFromJSON = PaymentMethodsEnumFromJSON;
function PaymentMethodsEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PaymentMethodsEnumFromJSONTyped = PaymentMethodsEnumFromJSONTyped;
function PaymentMethodsEnumToJSON(value) {
    return value;
}
exports.PaymentMethodsEnumToJSON = PaymentMethodsEnumToJSON;
